/// <amd-module name="Analytics/Boards/BurndownQueries/BurndownConfigurationContracts" />
import { ModefulValueSetting } from "Analytics/Boards/BoardsQueries/DataContracts";
import { DayOfWeek } from "Analytics/Common/System";

/** Describes schemes for  sampling data points over time*/
export enum DateSampleMode {
    /** Indicates the widget is sampling by dates */
    ByDateInterval,
    /** Indicates the widget is sampling on a set of iteration end dates */
    ByIterations
}

/** Describes allowed sample intervals for date sampling. */
export enum DateSampleInterval {
    Days,
    Weeks,
    Months
}

export interface DateSamplingConfiguration {
    /** Uses date format string (See CFD) */
    endDate: string;
    sampleInterval: DateSampleInterval;
    /** Describes the day of week to sample on - if weekly sampling is active. undefined, otherwise. */
    lastDayOfWeek: DayOfWeek;
}

export interface TimePeriodConfiguration {
    /*     * StartDate (Type: string)
     *     A date string (yyyy-MM-dd) defining the range of dates to show on the CFD
     *     from the start date to today.*/
    startDate: string;
    /** Describes sampling mode and contains storage.
     * -Dates uses DateSamplingConfiguration
     * -Iteration mode stores a array of iteration Guids as string */
    samplingConfiguration: ModefulValueSetting<DateSampleMode, string[] | DateSamplingConfiguration>;
}
